import { createContext } from 'react';
import connectedStoreModule from '@modules/products/store';
import { ProductsStoreAll } from '@modules/products/store/ProductsStoreAll';
import userStore from '@modules/core/store';
import UserStore from '@modules/core/store/UserStore';
import alertStore from '@modules/core/store';

export const StoreContext = createContext<AppStore>({
    ...userStore,
    ...alertStore,
    ...connectedStoreModule
});

export interface AppStore {
    userStore: UserStore;
    productsStoreAll: ProductsStoreAll;
}
